// eslint-disable-next-line import/prefer-default-export
export const houseConsignmentQueryKeys = {
  all: (consignmentId: number | null) => ['v3/house-consignment/list', consignmentId],
  details: (id: number) => ['v3/house-consignment', id],
}
